import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@/assets/icons/LibrarySvg';
/**
 * Строка списка персонажей на странице боевых карт: имя, клик по строке открывает детали,
 * отдельная кнопка добавляет или убирает персонажа с выбранной карты.
 */
const CombatMapCharacterListItem = ({ character, actionDisabled, rowAriaLabel = '', onOpenCharacter, onActionClick, actionLabel, actionAriaLabel = '', }) => {
    var _a;
    const handleActionClick = (event) => {
        event.stopPropagation();
        onActionClick(character);
    };
    const hasPortrait = Boolean((_a = character.imageUrl) === null || _a === void 0 ? void 0 : _a.trim());
    const rowStyle = hasPortrait
        ? {
            ['--character-bg-image']: `url(${JSON.stringify(character.imageUrl)})`,
        }
        : undefined;
    return (_jsxs("li", { className: hasPortrait ? 'character character--with-image' : 'character', style: rowStyle, children: [_jsxs("div", { className: "character-content", style: {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    minWidth: 0,
                    overflow: 'hidden',
                }, "aria-label": rowAriaLabel, onClick: () => onOpenCharacter(character), children: [!hasPortrait && (_jsx("div", { "aria-hidden": "true", style: {
                            position: 'absolute',
                            left: -10,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: 90,
                            height: 90,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            opacity: 0.3,
                        }, children: _jsx(Icon, { name: "goblin_1" }) })), _jsxs("div", { className: "character-name-container", style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'start',
                            justifyContent: 'center',
                            flex: '1 1 auto',
                            minWidth: 0,
                            height: '100%',
                            paddingLeft: 120,
                        }, children: [_jsx("span", { className: "character-name", style: {
                                    maxWidth: '90%',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }, children: character.name }), _jsx("span", { className: "character-description", style: {
                                    maxWidth: '90%',
                                    fontSize: '10px',
                                    fontWeight: '100',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }, children: character.description || '\u00A0' })] }), _jsx("div", { className: "character-stats", style: { display: 'flex', flexDirection: 'row', marginLeft: 'auto', flexShrink: 0 }, children: _jsxs("div", { className: "character-stats-container", style: { display: 'flex', flexDirection: 'column', gap: '5px' }, children: [_jsxs("span", { style: { fontSize: '10px' }, children: ["HP: ", character.health, "/", character.maxHealth] }), _jsxs("span", { style: { fontSize: '10px' }, children: ["AC: ", character.armorClass] })] }) })] }), _jsx("button", { type: "button", disabled: actionDisabled, "aria-label": actionAriaLabel, onClick: handleActionClick, children: actionLabel })] }));
};
export default CombatMapCharacterListItem;
